const Section = ({ title, children }) => (
    <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a1a2e', marginBottom: 12 }}>{title}</h2>
        <div style={{ fontSize: '0.9rem', color: '#374151', lineHeight: 1.9 }}>{children}</div>
    </section>
);

const PrivacyPolicyPage = () => {
    return (
        <div style={{ minHeight: '100vh', background: '#f5f6f8' }}>

            <div style={{ background: '#141c3d', padding: '32px 0' }}>
                <div style={{ maxWidth: 760, margin: '0 auto', padding: '0 16px' }}>
                    <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#fff', margin: '0 0 4px' }}>プライバシーポリシー</h1>
                    <p style={{ fontSize: '0.83rem', color: 'rgba(255,255,255,0.55)', margin: 0 }}>
                        個人情報の取り扱いについて
                    </p>
                </div>
            </div>

            <div style={{ maxWidth: 760, margin: '0 auto', padding: '28px 16px 60px' }}>
                <div style={{ background: '#fff', borderRadius: 10, padding: '32px 28px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>

                    <div style={{ background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 8, padding: '14px 16px', marginBottom: 32, fontSize: '0.82rem', color: '#92400e', lineHeight: 1.8 }}>
                        ※ このページはドラフトです。公開前に、事業者情報（会社名・所在地・代表者名・お問い合わせ窓口）欄の記入と、内容全体について弁護士の最終確認を受けてください。
                    </div>

                    <p style={{ fontSize: '0.9rem', color: '#374151', lineHeight: 1.9, marginBottom: 32 }}>
                        <strong>〔運営者名を記載〕</strong>（以下「当社」といいます）は、当社が提供する工事マッチングサービス「のりいれ三丁目」（以下「本サービス」といいます）における、お客様および施工業者様の個人情報の取り扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。
                    </p>

                    <Section title="1. 取得する個人情報">
                        <p style={{ marginBottom: 10 }}>本サービスでは、以下の個人情報を取得します。</p>
                        <p style={{ fontWeight: 600, color: '#1a1a2e', marginBottom: 4 }}>お客様（工事を依頼される方）</p>
                        <ul style={{ margin: '0 0 14px', paddingLeft: 20 }}>
                            <li>氏名・フリガナ</li>
                            <li>住所（現住所・工事先住所）、郵便番号</li>
                            <li>電話番号、メールアドレス</li>
                            <li>工事内容に関する情報（工事の種別・希望時期・現場写真・図面等）</li>
                            <li>決済に関する情報（後述のとおり、カード番号等の決済情報自体は決済代行会社が取り扱い、当社では保有しません）</li>
                        </ul>
                        <p style={{ fontWeight: 600, color: '#1a1a2e', marginBottom: 4 }}>施工業者様（工事を受注される事業者・ご担当者）</p>
                        <ul style={{ margin: '0 0 14px', paddingLeft: 20 }}>
                            <li>会社名・所在地・代表者名・電話番号・メールアドレス</li>
                            <li>保有資格・建設業許可番号・インボイス登録番号</li>
                            <li>振込先口座情報</li>
                            <li>本人確認・資格確認のための証明書類</li>
                        </ul>
                        <p>
                            また、本サービスの利用状況（アクセスログ・ログイン日時等）を、後述の目的の範囲であわせて取得する場合があります。
                        </p>
                    </Section>

                    <Section title="2. 利用目的">
                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                            <li>お客様と施工業者様のマッチング、見積もり・契約・工事に関するやり取りの仲介のため</li>
                            <li>本人確認（ログイン認証コードの送付を含む）のため</li>
                            <li>決済手続き（工事代金のお支払い・施工業者様への精算）のため</li>
                            <li>本サービスに関するご連絡・通知（ステータス変更のお知らせ等）のため</li>
                            <li>お問い合わせへの対応のため</li>
                            <li>施工業者様の登録審査（資格・許可番号の確認等）のため</li>
                            <li>本サービスの維持・改善、不正利用の防止のため</li>
                        </ul>
                    </Section>

                    <Section title="3. 第三者提供について">
                        <p style={{ marginBottom: 10 }}>
                            当社は、以下の場合を除き、ご本人の同意なく個人情報を第三者に提供することはありません。
                        </p>
                        <ul style={{ margin: '0 0 10px', paddingLeft: 20 }}>
                            <li>お客様が工事を依頼された施工業者様に対し、見積もり・工事の実施に必要な範囲で氏名・連絡先・工事先住所等をお伝えする場合</li>
                            <li>法令に基づく場合</li>
                            <li>人の生命・身体・財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき</li>
                        </ul>
                        <p>
                            なお、施工業者様の一部の情報（会社名・対応エリア・保有資格・実績・レビュー等）は、お客様が施工業者を選ぶための情報として本サービス上で公開されます。
                        </p>
                    </Section>

                    <Section title="4. 個人情報の取り扱いを委託する事業者">
                        <p style={{ marginBottom: 10 }}>
                            当社は、利用目的の達成に必要な範囲で、以下のような外部事業者に個人情報の取り扱いを委託することがあります。委託先に対しては、適切な管理を行うよう監督します。
                        </p>
                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                            <li>決済代行会社（カード情報等の決済処理のため）</li>
                            <li>クラウドサーバー・データ保管事業者（本サービスの稼働基盤、画像等のファイル保管のため）</li>
                            <li>メール配信事業者（認証コード・通知メールの送信のため）</li>
                        </ul>
                    </Section>

                    <Section title="5. Cookie等の利用について">
                        <p>
                            本サービスでは、ログイン状態の維持等のため、ブラウザのlocalStorage等にログイン認証情報（アクセストークン）を保存します。これらはログイン機能の提供以外の目的では利用しません。
                        </p>
                    </Section>

                    <Section title="6. 個人情報の安全管理">
                        <p>
                            当社は、取得した個人情報の漏えい・滅失・毀損の防止その他の安全管理のために、適切な措置を講じます。
                        </p>
                    </Section>

                    <Section title="7. 保有個人データの開示・訂正・利用停止等">
                        <p>
                            ご本人からご自身の個人情報について開示・訂正・追加・削除・利用停止等のご請求があった場合、ご本人からのご請求であることを確認の上、法令に従い遅滞なく対応いたします。ご請求は下記のお問い合わせ窓口までご連絡ください。
                        </p>
                    </Section>

                    <Section title="8. お問い合わせ窓口">
                        <p style={{ margin: 0 }}>
                            〔運営者名〕<br />
                            〔所在地〕<br />
                            〔お問い合わせメールアドレス／電話番号〕
                        </p>
                    </Section>

                    <Section title="9. 本ポリシーの変更">
                        <p>
                            当社は、法令の改正等に伴い、本ポリシーを変更することがあります。重要な変更を行う場合は、本サービス上でお知らせします。
                        </p>
                    </Section>

                    <p style={{ fontSize: '0.8rem', color: '#9ca3af', marginTop: 32 }}>
                        制定日：〔年月日〕
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
